import React from 'react';

const Input = ({
  label,
  error,
  hint,
  icon,
  fullWidth = true,
  className = '',
  containerClassName = '',
  ...props
}) => {
  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <div className={`${containerClassName}`}>
      {label && (
        <label className="block text-sm font-medium text-text-secondary mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted">
            {icon}
          </div>
        )}
        <input
          className={`
            ${widthClass}
            ${icon ? 'pl-10' : 'px-4'}
            py-3
            border-2
            ${error ? 'border-danger-500 focus:border-danger-500 focus:ring-danger-500/10' : 'border-neutral-200 focus:border-primary-500 focus:ring-primary-500/10'}
            rounded-lg
            focus:outline-none
            focus:ring-4
            transition-all
            duration-200
            text-base
            disabled:bg-neutral-100
            disabled:cursor-not-allowed
            ${className}
          `}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-danger-600 font-medium">{error}</p>
      )}
      {hint && !error && (
        <p className="mt-1.5 text-sm text-text-muted">{hint}</p>
      )}
    </div>
  );
};

export default Input;
